import AcxSelectSingle from "components/UI/Select/BaseSelectComponents/AcxSelectSingle";
import { LLMModel } from "models/LLMs";
import React, { useState, useCallback, useEffect } from "react";
import LLMModelsService from "services/LLMModelService";

type LLMModelSelectorProps = {
    getValue?: (options: LLMModel[]) => LLMModel | undefined;
    onOptionsLoaded?: (options: LLMModel[]) => void;
} & Partial<Omit<React.ComponentPropsWithoutRef<typeof AcxSelectSingle<LLMModel>>, "options">>;

export function LLMModelSelector(props: LLMModelSelectorProps) {
    const { getValue, onOptionsLoaded, ...selectProps } = props;
    const [options, setOptions] = useState<LLMModel[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchOptions = useCallback(async () => {
        if (isLoading || options.length > 0) return;

        try {
            setIsLoading(true);
            const service = new LLMModelsService();
            const models = await service.getLLMModels();
            setOptions(models);
            onOptionsLoaded?.(models);
        } finally {
            setIsLoading(false);
        }
    }, [isLoading, onOptionsLoaded, options]);

    useEffect(() => {
        void fetchOptions();
    }, [fetchOptions]);

    return (
        <AcxSelectSingle
            id="llm-model"
            valueField="name"
            labelField="name"
            fullWidth
            {...selectProps}
            defaultValue={selectProps.defaultValue ?? getValue?.(options)}
            isLoading={isLoading}
            options={options}
            onMenuOpen={fetchOptions}
        />
    );
}
